import { useQuery } from 'react-query';
import { useState, useEffect } from 'react';
import usePlanStore from 'store/planStore';
import { ApiResponse } from 'api/types';
import { AxiosError } from 'axios';
import {
  checkPlanName,
  CheckPlanNameResponse,
  CheckPlanNameError,
} from '../../../../../../../api/services/mediaPlanning/checkPlanName';

const useCheckPlanName = () => {
  const { generalInfoState } = usePlanStore();
  const [debouncedName, setDebouncedName] = useState(
    generalInfoState.campaignName
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedName(generalInfoState.campaignName);
    }, 800);

    return () => {
      clearTimeout(handler);
    };
  }, [generalInfoState.campaignName]);

  const { data, isFetching, error } = useQuery<
    ApiResponse<CheckPlanNameResponse>,
    AxiosError<CheckPlanNameError>
  >({
    queryKey: [debouncedName, 'check-campaign-name'],
    queryFn: () => checkPlanName(debouncedName),
    enabled: !!debouncedName,
    retry: 0,
    staleTime: 30000,
  });

  return {
    status: data?.status,
    message: data?.data?.message ?? '',
    isFetching,
    error,
  };
};

export default useCheckPlanName;
